module.exports = __webpack_public_path__ + "img/confetti_1c.2edb9a31.svg";